import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { DESCARGA_NF } from '~/constants/modules';
import { IconBarrel } from '~/icons';
import {
  Card as CardUI,
  CardContent,
  CardActions,
  Typography,
  Grid,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import {
  NotificationsOutlined,
  Wifi,
  ChangeHistory,
  ExitToApp,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { t, can  } from '~/helpers';

import { options } from './chart';

const useStyles = makeStyles(() => ({
  '@keyframes blink': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 0 },
  },
  imageContainer: {
    height: 64,
    width: 64,
    margin: '0 auto',
    border: `1px solid #333`,
    borderRadius: '5px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  compactIconButton: {
    width: 45,
    height: 45,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  compactIcon: {
    fontSize: '2rem',
  },
  chartContainer: {
    height: 200,
    position: 'relative',
  },
  appBar: {
    position: 'fixed',
  },
  dialog: {
    backgroundColor: '#f4f6f8',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
  },
  content: {
    marginTop: 85,
    backgroundColor: '#f4f6f8',
  },
  statsIcon: {
    color: 'primary',
  },
  statsIconAlert: {
    color: 'red',
    animation: '$blink .75s linear infinite',
  },
}));



export default function Card(props) {
  const classes = useStyles();
  const { station, showStation, showAlarms } = props;

  const colorAlarm = useMemo(
    () => (station.alarmes ? classes.statsIconAlert : classes.statsIcon),
    [station, classes]
  );

  const tooltipDescarga = useMemo(() => {
    if (!station.em_descarga) {
      return t('c.menu.stock.acaorecementoemandamento');
    }

    if (!station.produtos_em_descarga || station.produtos_em_descarga.length === 0) {
      return t('c.menu.stock.acaorecementoemandamento');
    }

    return `${t('c.menu.stock.acaorecementoemandamento')}: ${station.produtos_em_descarga.join(', ')}`;
  }, [station]);

  const colorDescarga = useMemo(
    () => (station.em_descarga ? classes.statsIconAlert : classes.statsIcon),
    [station, classes]
  );

  const colorCommunication = useMemo(
    () =>
      station.status_comunicacao ? classes.statsIconAlert : classes.statsIcon,
    [station, classes]
  );

  const colorResupply = useMemo(
    () =>
      station.alerta_ressuprimento ? classes.statsIconAlert : classes.statsIcon,
    [station, classes]
  );

  return (
    <Grid item md={4} sm={12}>
      <CardUI>
        <CardContent>
          <Typography align="center" gutterBottom>
            {station.title}
          </Typography>
          <div style={{ height: '200px', position: 'relative' }}>
            <Bar data={station.data} options={options} />
          </div>
        </CardContent>

        <Divider />

        <CardActions>
          <Grid container justify="space-around">
            <Grid item>
              <IconButton
                onClick={() =>
                  station.alarmes ? showAlarms(station) : undefined
                }
              >
                <Tooltip title={t('c.menu.alarme.titulo')}>
                  <NotificationsOutlined className={colorAlarm} />
                </Tooltip>
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton>
                <Tooltip title={t('c.menu.stock.statuscomunicacao')}>
                  <Wifi className={colorCommunication} />
                </Tooltip>
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton>
                <Tooltip title={t('c.menu.stock.alartaderesuprimento')}>
                  <ChangeHistory className={colorResupply} />
                </Tooltip>
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton onClick={() => showStation(station)}>
                <Tooltip title={t('c.menu.stock.exibirtanquesdoposto')}>
                  <ExitToApp className={classes.statsIcon} />
                </Tooltip>
              </IconButton>
            </Grid>
            {can(DESCARGA_NF) && station.tipodescargaposto === 1 && (
              <Grid item className={classes.statsItem}>
                <Tooltip title={tooltipDescarga}>
                  <span>
                    <IconButton className={classes.compactIconButton} disabled>
                      <IconBarrel
                        className={`${classes.compactIcon} ${colorDescarga}`}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </CardActions>
      </CardUI>
    </Grid>
  );
}

Card.propTypes = {
  showAlarms: PropTypes.func.isRequired,
  showStation: PropTypes.func.isRequired,
  station: PropTypes.objectOf(PropTypes.any).isRequired,
};
